import { ExternalDependenciesRules } from 'types/external-dependencies-rules';
import { HFModelData } from 'types/model';

export const getExternalDepsRules = (model: HFModelData | null): ExternalDependenciesRules => {
  if (model && model?.externalDependenciesRules) {
    return model.externalDependenciesRules;
  }

  return {
    disabled: false,
    excludeAppsflyerByPatternURL: '',
    excludeCdpByPatternURL: '',
  };
};

/**
 * @param { string } path - url path
 * @param { string } patters - regex string split pipe
 * @example
 * const patters = '/okapi/*|/okapi/header*';
 * const path = '/okapi/header-footer/widget?widget=header-footer/header&data={}'
 * const excludeUrl = isPathExclude(path, patters) // return true
 * если логика обновлена то нужно обновить в https://codesandbox.io/p/sandbox/c43wsx?file=%2Fsrc%2FApp.tsx%3A149%2C22
 */
export const isPathExclude = (path: string, patters: string): boolean => {
  if (!patters.length) return false;
  return new RegExp(patters).test(path);
};
